export default "__VITE_ASSET__BrGndL4m__"